"use strict";

var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
var _vuex = require("vuex");
var _DragDialog = _interopRequireDefault(require("@/components/DragDialog"));
var _blExchangeAppointmentSh = require("@/api/blExchangeAppointment/blExchangeAppointmentSh");
var _utils = require("@/utils");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: "authorizationDialog",
  components: {
    dragDialog: _DragDialog.default
  },
  props: {
    edoAccreditId: {
      type: String,
      default: ''
    },
    accreditBlNo: {
      type: String,
      default: ''
    },
    formDialog: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    displayType: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      forespeakStatusList: [],
      accreditStatusList: [{
        labelZh: '未授权',
        labelEn: 'Unauthorized',
        value: 0
      }, {
        labelZh: '已授权',
        labelEn: 'Authorized',
        value: 1
      }, {
        labelZh: '授权取消中',
        labelEn: 'Authorization cancellation',
        value: 3
      }],
      form: {
        edoAccreditId: "",
        accreditBlNo: "",
        forespeakStatus: "",
        accreditStatus: "",
        sipgCstCode: "",
        creditCode: "",
        cstName: ""
      }
    };
  },
  computed: (0, _objectSpread2.default)({}, (0, _vuex.mapGetters)(['language'])),
  mounted: function mounted() {
    var _this = this;
    this.$dictionary.get(['DOC_FORESPEAK_STATUS'], true).then(function (res) {
      res = JSON.parse(JSON.stringify(res));
      _this.forespeakStatusList = res.DOC_FORESPEAK_STATUS ? res.DOC_FORESPEAK_STATUS : [];
    });
  },
  methods: {
    selectSipgCstCodeChange: function selectSipgCstCodeChange(row, data) {
      this.form.sipgCstCode = data.sipgCstCode;
      this.form.creditCode = data.creditCode;
      this.form.cstName = data.cstName;
    },
    handleCancel: function handleCancel() {
      var _this2 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointmentSh.cancelAccredit)(this.form.edoAccreditId).then(function (res) {
        if (res.success) {
          _this2.$message(res.data);
          _this2.closed();
        }
      }).finally(function () {
        _this2.loading.close();
      });
    },
    handleSave: function handleSave() {
      var _this3 = this;
      this.loading = (0, _utils.load)();
      (0, _blExchangeAppointmentSh.accreditDocEdoAccredit)(this.form).then(function (res) {
        if (res.success) {
          _this3.$message(res.data);
          _this3.closed();
        }
      }).finally(function () {
        _this3.loading.close();
      });
    },
    opened: function opened() {
      var _this4 = this;
      this.$nextTick(function () {
        _this4.form = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, _this4.form), _this4.formDialog);
        _this4.form.accreditBlNo = _this4.accreditBlNo;
        _this4.form.edoAccreditId = _this4.edoAccreditId;
      });
    },
    closed: function closed() {
      this.$emit('handleCloseAuthorization');
    },
    handleClose: function handleClose() {
      this.$emit('update:visible', false);
    }
  }
};